import PropTypes from "prop-types";

function ThankViewIntegrationStatus({ status }) {
  const stats = {
    inactive: { color: "#DE1B2C", text: "INACTIVE" },
    active: { color: "#53A744", text: "ACTIVE" },
    notavailable: { color: "#00C0F5", text: "NOT AVAILABLE" },
  };
  return (
    <div>
      <div key={status} style={{ color: stats[status].color }} className="profile-engagement-metrics--status">
        {stats[status].text}
      </div>
    </div>
  );
}

ThankViewIntegrationStatus.propTypes = {
  status: PropTypes.string,
};

export default ThankViewIntegrationStatus;
